module.exports = __webpack_public_path__ + "static/media/bg-three.7be4e13f.png";